import Popup from '../Popup';
import HideOffscreenSlides from '../../../../components/modules/swiper-hide-offscreen';

class CardPopup extends Popup {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);

    this.swiper = {
      Swiper: null,
      swiperElement: null,
      modules: {},
    };
    this.activeTab = null;
  }

  cacheElements() {
    const popup = this.container.querySelector('.brand-venues__popup-card');

    return {
      popup,
      showButtons: this.container.querySelectorAll('.brand-venues__action-card'),
      tabSelect: this.container.querySelector('.brand-venues__tab-select'),
    };
  }

  init() {
    this.container.addEventListener('click', (e) => {
      const trigger = e.target.closest('.brand-venues__trigger--detail');
      if (!trigger) return;

      this.handleDetailTriggerClick(e, trigger);
    });

    this.container.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const trigger = e.target.closest('.brand-venues__trigger--detail');
      if (!trigger) return;

      this.handleDetailTriggerClick(e, trigger);
    });

    document.addEventListener(this.openEventName, (event) => {
      const { parentEvent } = event.detail;
      this.listenCardButton(parentEvent);
    });

    // Listen for tab changes (desktop tabs)
    this.elements?.popup.addEventListener('change', (e) => {
      if (e.target.type === 'radio' && e.target.name === 'tabs') {
        this.listenTabChange(e);
      }
    });

    this.elements?.popup.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const tabLabel = e.target.closest('.brand-venues__tab-label');
      if (!tabLabel) return;

      e.preventDefault();
      tabLabel.click();
    });

    // Listen for mobile select changes
    this.elements?.tabSelect.addEventListener('change', (e) => {
      this.listenSelectChange(e);
    });

    this.bindVideoToggles();
    this.bindVideoStateSync();

    document.addEventListener(this.closeEventName, () => {
      CardPopup.stopVideo(this.elements.popup);

      setTimeout(() => {
        if (this.swiper.swiperElement) {
          this.swiper.swiperElement.destroy();
          this.swiper.swiperElement = null;
        }
        const activeItem = document.querySelector('.brand-venues__popup-item--active');
        if (activeItem) {
          activeItem.classList.remove('brand-venues__popup-item--active');
        }
      }, 150);
    });

    super.init();
  }

  listenCardButton(event) {
    const { target } = event;

    const actionTarget = target.closest('.brand-venues__action-card') || target;
    const actionType = actionTarget.getAttribute('data-action-type');
    const cardEl = target.closest('.brand-venues__card');
    const hotelID = cardEl?.getAttribute('data-hotel-id');

    if (!cardEl || !hotelID) {
      return;
    }

    if (!actionType) {
      return;
    }

    event.preventDefault();

    if (actionType && hotelID) {
      this.openPopupForHotel(hotelID, actionType);
    }
  }

  openPopupForHotel(hotelID, actionType) {
    const activeTab = this.elements.popup.querySelector(`#${actionType}`);
    const activeItem = this.elements.popup.querySelector(
      `.brand-venues__popup-item[data-id="${hotelID}"]`,
    );

    if (activeTab && activeItem) {
      this.elements.popup.setAttribute('data-hotel-id', hotelID);

      const allActiveItems = this.elements.popup.querySelectorAll('.brand-venues__popup-item--active');
      allActiveItems.forEach((item) => item.classList.remove('brand-venues__popup-item--active'));

      activeItem.classList.add('brand-venues__popup-item--active');
      activeTab.checked = true;

      const altsBlocks = document.querySelectorAll('.brand-venues__popup-alts');
      altsBlocks.forEach((alts) => {
        if (alts.getAttribute('data-id') === hotelID) {
          alts.removeAttribute('hidden');
        } else {
          alts.setAttribute('hidden', '');
        }
      });

      this.manageSelectOptions(activeItem);

      if (this.elements.tabSelect) {
        this.elements.tabSelect.value = actionType;
      }

      this.initSwiper(actionType, hotelID);
      this.setAriaTabControls(hotelID);
      this.setTabAriaAttributes(activeTab);
    } else {
      this.elements.popup.close();
    }
  }

  manageSelectOptions(activeItem) {
    if (!this.elements.tabSelect) {
      return;
    }

    const sides = this.elements.tabSelect.querySelectorAll('option');
    const hotelSidesArr = [...activeItem.querySelectorAll('.brand-venues__popup-side')];

    sides.forEach((side) => {
      const { value } = side;
      const exists = hotelSidesArr.some((h) => h.dataset.tab === value);
      // eslint-disable-next-line no-param-reassign
      side.disabled = !exists;
    });
  }

  handleDetailTriggerClick(e, triggerEl) {
    e.preventDefault();
    const hotelID = triggerEl.closest('.brand-venues__card')?.getAttribute('data-hotel-id');
    const imageUrl = triggerEl.getAttribute('data-image-url');
    const imageId = triggerEl.getAttribute('data-image-id');

    if (!hotelID || (!imageId && !imageUrl)) return;

    const openButton = triggerEl.closest('.brand-venues__card')
      .querySelector('.brand-venues__action-card[data-action-type="venue_images"]');

    if (openButton) {
      this.showPopup(e, openButton);
    } else {
      CardPopup.lockWindow();
      this.elements.popup.showModal();
      this.elements.popup.classList.add('brand-venues__popup-backdrop--visible');
    }

    this.openPopupForHotel(hotelID, 'venue_images');

    this.scrollToImage({ id: imageId, url: imageUrl });
  }

  scrollToImage({ id = null, url = null }) {
    let attempts = 0;
    const maxAttempts = 20;
    const tryScroll = () => {
      const activeItem = document.querySelector('.brand-venues__popup-item--active');
      const images = activeItem?.querySelectorAll("[data-tab='venue_images'] .swiper-slide img");

      if (!this.swiper.swiperElement || !images || images.length === 0) {
        if (attempts < maxAttempts) {
          attempts += 1;
          setTimeout(tryScroll, 50);
        }
        return;
      }

      let index = -1;

      if (id) {
        images.forEach((img, i) => {
          if (img.getAttribute('data-attachment-id') === id) {
            index = i;
          }
        });
      }

      if (index < 0 && url) {
        images.forEach((img, i) => {
          if (img.getAttribute('src') === url) {
            index = i;
          }
        });
      }

      if (index >= 0) {
        this.swiper.swiperElement.slideTo(index, 0);
        this.swiper.swiperElement.update();
        this.swiper.swiperElement.pagination.render();
        this.swiper.swiperElement.pagination.update();
        this.swiper.swiperElement.emit('paginationUpdate');
      }
    };

    tryScroll();
  }

  scrollToImageByUrl(url) {
    let attempts = 0;
    const maxAttempts = 20;
    const tryScroll = () => {
      const activeItem = document.querySelector('.brand-venues__popup-item--active');
      const images = activeItem?.querySelectorAll("[data-tab='venue_images'] .swiper-slide img");

      if (!this.swiper.swiperElement || !images || images.length === 0) {
        if (attempts < maxAttempts) {
          attempts += 1;
          setTimeout(tryScroll, 50);
        }
        return;
      }

      let index = -1;
      images.forEach((img, i) => {
        if (img.getAttribute('src') === url) {
          index = i;
        }
      });

      if (index >= 0) {
        this.swiper.swiperElement.slideTo(index, 0);
        this.swiper.swiperElement.update();
        this.swiper.swiperElement.pagination.render();
        this.swiper.swiperElement.pagination.update();
        this.swiper.swiperElement.emit('paginationUpdate');
      }
    };

    tryScroll();
  }

  listenTabChange(e) {
    CardPopup.stopVideo(this.elements.popup);
    this.setTabAriaAttributes(e.target);
    const actionType = e.target.id;

    if (this.elements.tabSelect) {
      this.elements.tabSelect.value = actionType;
    }

    this.initializeSwiper(actionType);
  }

  listenSelectChange(e) {
    const actionType = e.target.value;
    CardPopup.stopVideo(this.elements.popup);

    const desktopTab = this.elements.popup.querySelector(`#${actionType}`);
    if (desktopTab) {
      desktopTab.checked = true;
      this.setTabAriaAttributes(desktopTab);
    }

    this.initializeSwiper(actionType);
  }

  initializeSwiper(actionType) {
    const hotelID = this.elements.popup.getAttribute('data-hotel-id');

    if (this.swiper.swiperElement) {
      this.swiper.swiperElement.destroy();
      this.swiper.swiperElement = null;
    }

    this.initSwiper(actionType, hotelID);
  }

  async initSwiper(actionType, hotelID = null) {
    const activeItem = document.querySelector('.brand-venues__popup-item--active');

    if (activeItem) {
      const tabBody = CardPopup.getTabBody(activeItem, actionType);
      const swiperContainer = tabBody?.querySelector('.swiper');

      if (swiperContainer && hotelID) {
        if (!this.swiper.Swiper) {
          try {
            const SwiperModule = await import('swiper');
            this.swiper.Swiper = SwiperModule.Swiper;
            this.swiper.modules.Navigation = SwiperModule.Navigation;
            this.swiper.modules.Pagination = SwiperModule.Pagination;
          } catch (error) {
            return;
          }
        }

        const nextButton = document.querySelector('.brand-venues__popup .brand-venues__popup-arrows .brand-venues__popup-arrow--right');
        const prevButton = document.querySelector('.brand-venues__popup .brand-venues__popup-arrows .brand-venues__popup-arrow--left');
        const paginationBlock = document.querySelector('.brand-venues__popup .swiper-pagination');

        if (paginationBlock) {
          paginationBlock.innerHTML = '';
        }

        this.swiper.swiperElement = new this.swiper.Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 30,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          pagination: {
            el: paginationBlock,
            type: 'bullets',
            clickable: true,
          },
          modules: [
            this.swiper.modules.Navigation,
            this.swiper.modules.Pagination,
            HideOffscreenSlides,
          ],
          breakpoints: {
            768: {
              slidesPerView: 1,
            },
          },
        });

        this.swiper.swiperElement.update();
        this.swiper.swiperElement.pagination.update();
        this.swiper.swiperElement.navigation.update();

        this.swiper.swiperElement.on('paginationUpdate', (el) => {
          const { activeIndex } = el;
          let alts = [];
          let type = [];
          const { activeTab } = this;
          const activeClass = 'brand-venues__popup-alt-text--active';

          if (activeTab.getAttribute('for') === 'floor_plans') {
            type = 'floor';
          } else if (activeTab.getAttribute('for') === 'venue_images') {
            type = 'media';
          }

          alts = this.container.querySelectorAll(`.brand-venues__popup-alts[data-id="${hotelID}"] .brand-venues__popup-alt-text`);
          const altsWithType = this.container.querySelectorAll(`.brand-venues__popup-alts[data-id="${hotelID}"] .brand-venues__popup-alt-text--${type}`);

          alts.forEach((alt) => alt.classList.remove(activeClass));
          altsWithType[activeIndex].classList.add(activeClass);
        });

        // Manage video tabindex on slide change
        this.swiper.swiperElement.on('slideChange', (el) => {
          CardPopup.manageVideoAccessibility(el);
        });

        // Initialize accessibility on first slide
        CardPopup.manageVideoAccessibility(this.swiper.swiperElement);

        this.swiper.swiperElement.emit('paginationUpdate');
      }
    }
  }

  setTabAriaAttributes(activeTabInput) {
    const activeTab = activeTabInput.nextElementSibling;

    if (this.activeTab) {
      this.activeTab.setAttribute('aria-selected', 'false');
    }

    this.activeTab = activeTab;
    this.activeTab.setAttribute('aria-selected', 'true');
  }

  setAriaTabControls(hotelId) {
    const tabControls = this.elements.popup.querySelectorAll('.brand-venues__tab-label');
    tabControls.forEach((tabControl) => {
      tabControl.setAttribute('aria-controls', `${tabControl.getAttribute('for')}-${hotelId}`);
    });
  }

  static getTabBody(activeItem, actionType) {
    const tabParts = activeItem.querySelectorAll('.brand-venues__popup-side');
    let tabBody = null;

    // eslint-disable-next-line consistent-return
    tabParts.forEach((tabPart) => {
      if (tabPart.getAttribute('data-tab') === actionType) {
        tabBody = tabPart;
      }
    });

    return tabBody;
  }

  static stopVideo(popupElement) {
    if (!popupElement) return;

    const videos = popupElement.querySelectorAll('video');
    const videoIframe = popupElement.querySelector('.brand-venues__popup-item--active iframe');

    videos.forEach((video) => {
      if (!video.paused && !video.ended && video.currentTime >= 0) {
        video.pause();
      }
      CardPopup.updateVideoToggle(video, false);
    });

    if (videoIframe && videoIframe.contentWindow) {
      videoIframe.contentWindow.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'pauseVideo',
        }),
        '*',
      );
    }
  }

  static manageVideoAccessibility(swiperInstance) {
    const { slides } = swiperInstance;
    const { activeIndex } = swiperInstance;

    if (!slides) return;

    slides.forEach((slide, index) => {
      const video = slide.querySelector('video');
      if (!video) return;

      if (index === activeIndex) {
        // Active slide - make video accessible
        video.setAttribute('tabindex', '0');
      } else {
        // Inactive slide - make video inaccessible
        video.setAttribute('tabindex', '-1');
      }
    });
  }

  bindVideoToggles() {
    if (!this.elements?.popup) return;

    this.elements.popup.addEventListener('click', (event) => {
      const toggle = event.target.closest('.card_popup-invisible-focus');
      if (!toggle) return;
      this.handleVideoToggle(event, toggle);
    });

    this.elements.popup.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const toggle = event.target.closest('.card_popup-invisible-focus');
      if (!toggle) return;
      event.preventDefault();
      this.handleVideoToggle(event, toggle);
    });
  }

  bindVideoStateSync() {
    if (!this.elements?.popup) return;

    const videos = this.elements.popup.querySelectorAll('.brand-venues__popup-video');
    videos.forEach((video) => {
      video.addEventListener('play', () => {
        CardPopup.updateVideoToggle(video, true);
      });
      video.addEventListener('pause', () => {
        CardPopup.updateVideoToggle(video, false);
      });
      CardPopup.updateVideoToggle(video, !video.paused && !video.ended && video.currentTime > 0);
    });
  }

  handleVideoToggle(event, toggle) {
    event.preventDefault();

    const video = toggle.closest('.brand-venues__side-tour')?.querySelector('video');
    if (!video) return;

    if (video.paused || video.ended) {
      CardPopup.stopVideo(this.elements.popup);
      const playPromise = video.play();
      CardPopup.updateVideoToggle(video, true);
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          CardPopup.updateVideoToggle(video, false);
        });
      }
      return;
    }

    video.pause();
    CardPopup.updateVideoToggle(video, false);
  }

  static getVideoToggle(video) {
    return video.closest('.brand-venues__side-tour')?.querySelector('.card_popup-invisible-focus');
  }

  static updateVideoToggle(video, isPlaying) {
    if (!video) return;
    const toggle = CardPopup.getVideoToggle(video);
    if (!toggle) return;

    const playLabel = toggle.dataset?.playLabel || toggle.getAttribute('data-play-label') || '';
    const pauseLabel = toggle.dataset?.pauseLabel || toggle.getAttribute('data-pause-label') || playLabel;

    toggle.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    toggle.setAttribute('aria-label', isPlaying ? pauseLabel : playLabel);
  }
}

export default CardPopup;
